import React from 'react';

import { Footer, Header, PageLayout } from '../../components';
import PageContent from '../../features/UpdatePolicies';
import { useAuthValidation } from '../../utils/hooks';

const UpdatePoliciesPage = () => {
  useAuthValidation();

  return (
    <>
      <Header />
      <PageLayout>
        <PageContent />
      </PageLayout>
      <Footer />
    </>
  );
};

export default UpdatePoliciesPage;
